module.exports = __webpack_public_path__ + "img/banner3.a836e43a.png";